import i18next from 'i18next';

import {Colors} from 'web-app/styleguide/colors';
import {getThemeColor} from 'web-app/styleguide/color-helpers';

export const NEW_EMPLOYEE_SUBMIT_BUTTON_ID = 'NEW_EMPLOYEE_SUBMIT_BUTTON_ID';
export const FORM_NAME = 'new-employee-form';
export const DONT_SEND_LOGIN_KEY = 'DONT_SEND_LOGIN_KEY';

export const getDontSendLoginOption = () => ({
    label: i18next.t('addEmployeeModal.dontSendLogin'),
    value: DONT_SEND_LOGIN_KEY,
    iconColor: getThemeColor(Colors.Text),
});
